import { DirectionDto } from 'api/generated';
import { useMemo } from 'react';
import { selectors, useAppSelector } from 'store';
import { Theme } from 'styles/themes';
import { appDefaultColors } from 'styles/themes/appDefaultColors';
import { getCoursePrimaryColor } from 'utils';

const useThemeMode = (direction: DirectionDto | null) => {
  const isDarkMode = useAppSelector(selectors.settings.isDarkMode);
  const activeCourse = useAppSelector(selectors.courses.selectActiveCourse);
  const selectedCourse = useAppSelector(selectors.courses.selectCourse);
  const publicCourse = useAppSelector(selectors.courses.selectPublicCourse);

  // App palette should follow the currently active course when available.
  // `selectedCourse` is used in some flows (e.g. purchase) and can become stale,
  // which previously prevented palette updates when switching active courses.
  const themeCourse = activeCourse || selectedCourse || publicCourse;
  const primaryColor = getCoursePrimaryColor(themeCourse, direction?.mainColorHex);
  const theme = useMemo(
    () =>
      new Theme(primaryColor, isDarkMode ? appDefaultColors.dark : appDefaultColors.default, {
        old: direction?.oldColorHex || '',
      }),
    [primaryColor, isDarkMode, direction?.oldColorHex],
  );

  return theme;
};

export default useThemeMode;
